// COMMENT: CREATE THIS FILE
export const LOADING_MEDICAL_NAME_ENTITIES = "LOADING_MEDICAL_NAME_ENTITIES";
export const GET_MEDICAL_NAME_ENTITIES_SUCCESS = "GET_MEDICAL_NAME_ENTITIES_SUCCESS";
export const GET_MEDICAL_NAME_ENTITIES_FAILURE = "GET_MEDICAL_NAME_ENTITIES_FAILURE";